// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"polyfills-dom":"bf1b97e26db9a798","polyfills-core-js":"5ac2e555128e234c","node_modules_profabric_web-components_dist_esm_pf-button_6_entry_js":"c4b3930b527901dc"}[chunkId] + ".js";
};